import { render, staticRenderFns } from "./ServerLoad.vue?vue&type=template&id=56a4d3a0&"
import script from "./ServerLoad.vue?vue&type=script&lang=js&"
export * from "./ServerLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports